interface ToastProps {
  message: string | null;
}

export default function Toast({ message }: ToastProps) {
  return (
    <div
      className={`pointer-events-none fixed bottom-6 left-1/2 z-50 -translate-x-1/2 px-4 transition-all duration-300 ${
        message ? 'translate-y-0 opacity-100' : 'translate-y-3 opacity-0'
      }`}
    >
      <div className="flex items-center gap-2 rounded-full bg-foreground-950 px-4 py-2.5 text-sm text-background-50">
        <span className="flex h-4 w-4 items-center justify-center text-accent-400">
          <i className="ri-flashlight-fill"></i>
        </span>
        {message}
      </div>
    </div>
  );
}